var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyFormRow',{attrs:{"label":_vm.label,"width":_vm.labelWidth,"labelAlign":_vm.labelAlign,"color":_vm.color}},[_c('div',{staticClass:"text",style:({ marginBottom: _vm.textMarginBottom })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }